module.exports = __webpack_public_path__ + "static/media/obama.f155ef69.jpg";